(() => {
  if (window.cartGiftOptionsLoaded) return;
  window.cartGiftOptionsLoaded = true;
  const root = window.Shopify?.routes?.root || '/';
  let dialog;
  let busy = false;

  async function request(path, body) {
    const response = await fetch(`${root}${path}`, body === undefined ? {} : {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Unable to update gift options. Please try again.');
    return result;
  }

  function setBusy(value) {
    busy = value;
    dialog.setAttribute('aria-busy', String(value));
    dialog.querySelectorAll('button, textarea').forEach(element => { element.disabled = value; });
    const wrap = dialog.querySelector('[data-gift-wrap]');
    wrap.disabled = value || wrap.dataset.unavailable === 'true';
  }

  function showError(error) {
    const element = dialog.querySelector('[data-gift-error]');
    element.textContent = error.message || 'Unable to update gift options. Please try again.';
    element.hidden = false;
  }

  async function open(trigger) {
    if (dialog?.open) return;
    const template = trigger.closest('.cart-gift-options').querySelector('[data-gift-template]');
    dialog = template.content.firstElementChild.cloneNode(true);
    // Keep the modal outside the drawer so cart section replacements cannot destroy it.
    document.body.append(dialog);
    const wrap = dialog.querySelector('[data-gift-wrap]');
    wrap.dataset.unavailable = String(wrap.disabled);
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
    dialog.addEventListener('cancel', event => {
      // Escape should close this dialog without also closing the cart drawer.
      event.preventDefault();
      if (!busy) dialog.close();
    });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'Escape') event.stopPropagation();
    });
    dialog.addEventListener('close', () => {
      dialog.remove();
      const drawer = document.querySelector('cart-drawer.active');
      const focusTarget = document.querySelector('[data-gift-open]');
      if (drawer && typeof trapFocus === 'function') trapFocus(drawer.querySelector('#CartDrawer'), focusTarget || drawer.querySelector('.drawer__close'));
      else if (trigger.isConnected) trigger.focus();
    }, { once: true });
    dialog.showModal();
    setBusy(true);
    try {
      const cart = await request('cart.js');
      wrap.checked = cart.items.some(item => String(item.variant_id) === dialog.dataset.variantId);
      dialog.querySelector('[data-gift-note]').value = cart.note || '';
      dialog.querySelector('[data-gift-remove]').hidden = !wrap.checked && !cart.note;
    } catch (error) {
      showError(error);
      // Do not allow saving an empty draft when the current cart could not be loaded.
      dialog.querySelector('[data-gift-save]').dataset.loadFailed = 'true';
    } finally {
      setBusy(false);
      if (dialog.querySelector('[data-gift-save]').dataset.loadFailed) {
        dialog.querySelector('[data-gift-save]').disabled = true;
        dialog.querySelector('[data-gift-remove]').disabled = true;
      }
    }
  }

  async function save(remove) {
    if (busy) return;
    const note = remove ? '' : dialog.querySelector('[data-gift-note]').value;
    const selected = !remove && dialog.querySelector('[data-gift-wrap]').checked;
    const variantId = dialog.dataset.variantId;
    setBusy(true);
    dialog.querySelector('[data-gift-error]').hidden = true;
    const button = dialog.querySelector(remove ? '[data-gift-remove]' : '[data-gift-save]');
    button.textContent = remove ? 'Removing…' : 'Saving…';
    try {
      const cart = await request('cart.js');
      const giftItems = cart.items.filter(item => String(item.variant_id) === variantId);
      if (selected && !giftItems.length) await request('cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] });
      const updates = {};
      if (!selected) giftItems.forEach(item => { updates[item.key] = 0; });
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer ? drawer.getSectionsToRender().map(section => section.id) : ['cart-icon-bubble'];
      const updatedCart = await request('cart/update.js', { note, updates, sections, sections_url: window.location.pathname });
      // Keep the draft open if Shopify saved the cart but could not render the sections.
      if (sections.some(id => !updatedCart.sections?.[id])) throw new Error('Gift options were saved, but the cart could not refresh. Please reload the page.');
      dialog.close();
      if (drawer) drawer.renderContents(updatedCart);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: updatedCart });
      }
    } catch (error) {
      showError(error);
    } finally {
      setBusy(false);
      button.textContent = remove ? 'Remove' : 'Save';
    }
  }

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-gift-open]');
    if (trigger) { open(trigger); return; }
    if (!dialog?.open || !dialog.contains(event.target)) return;
    if (event.target.closest('[data-gift-close]') && !busy) dialog.close();
    else if (event.target.closest('[data-gift-save]')) save(false);
    else if (event.target.closest('[data-gift-remove]')) save(true);
  });
})();
